import { render } from "./batteryInfo.vue?vue&type=template&id=9b010a44&scoped=true&ts=true"
import script from "./batteryInfo.vue?vue&type=script&lang=ts"
export * from "./batteryInfo.vue?vue&type=script&lang=ts"

import "./batteryInfo.vue?vue&type=style&index=0&id=9b010a44&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b010a44"]])

export default __exports__